export interface StatusReportRow {
  userId: number | null;
  fullName: string;
  isActive: boolean;
  counts: Record<string, number>;
}

export interface StatusReportResponse {
  success: boolean;
  rows: StatusReportRow[];
}

export const STATUS_REPORT_COLUMNS: { value: string; label: string }[] = [
  { value: 'hivando', label: 'Hívandó' },
  { value: 'visszahivando', label: 'Visszahívandó' },
  { value: 'elutasitott', label: 'Elutasított' },
  { value: 'robinson_listas', label: 'Robinson listás' },
  { value: 'nem_vette_fel', label: 'Nem vette fel' },
  { value: 'egyeztetett-kum', label: 'Egyeztetett (KÜM)' },
  { value: 'egyeztetett-vagyon', label: 'Egyeztetett (vagyon)' },
  { value: 'egyeztetett-kv', label: 'Egyeztett (K+v)' }
];
